<template>
    <el-form ref="form" :model="form" class="box-set" label-width="120px">
        <el-card header="设置规则名称" shadow="naver">
            <el-form-item label="名称" prop="line_name" :rules="{required: true, message: '请填写规则名称', trigger: 'blur'}">
                <el-col :span="20">
                    <el-input v-model="form.line_name" :maxlength=30 placeholder="最多30个字"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="充值面额">
              <el-radio-group v-model="form.line_many">
                <template><el-radio :label="50">50元</el-radio></template>
                <template><el-radio :label="100">100元</el-radio></template>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="有效期">
                <el-col :span="20">
                    <el-date-picker
                            v-model="activity_date"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="生效时间"
                            end-placeholder="过期时间"
                            format="yyyy/MM/dd HH:mm:ss"
                            value-format="timestamp"
                            :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                </el-col>
            </el-form-item>

        </el-card>
        <el-card header="选择限购商品" shadow="naver">
            <SkuSelector @change="getItems" :data="relItems"></SkuSelector>
        </el-card>
        <div class="content-center">
            <!-- <el-button type="primary" v-if="this.copy_flag" @click="submitActivityAction()">复制活动</el-button> -->

            <el-button type="primary" v-if="hasSaveButton && !this.copy_flag" @click="submitActivityAction()">保存</el-button>
            <el-button @click.native="handleCancel">返回</el-button>
        </div>
    </el-form>
</template>

<script>
  import SkuSelector from '@/components/function/skuSelector'
  import {getGradeList} from '../../../../api/membercard'
  import {listVipGrade} from '../../../../api/cardticket'
  import {createGive, getGiveInfo, updateGive,getGive} from '../../../../api/promotions'

  export default {
    components: {
      SkuSelector
    },
    data() {
      return {
        relItems: [],

        copy_flag:false,
        form: {
          line_name: '',
          items: [],
          start_time: 0,
          end_time: 0,
          line_many: 50,
        },
        relMain: [],
        setMainStatus: false,
        activity_date:'',
        mainVisible: false,
        hasSaveButton: true,
        listsLoading:false,
      }
    },
    methods: {
      getGiveLists() {
        this.listsLoading = true
        getGive().then(res => {
          this.listsLoading = false
          this.list = res.data.data.list
          this.total_count = res.data.data.total_count
        })
      },
      submitActivityAction() {
        const that = this
        if (this.activity_date.length > 0) {
          this.form.start_time = this.activity_date[0] / 1000
          this.form.end_time = this.activity_date[1] / 1000
        }
        // return
        if (this.$route.params.limit_id) {
          updateGive(this.$route.params.limit_id, this.form).then(response => {
            this.loading = false
            this.$message({
              message: '修改成功',
              type: 'success',
              duration: 2 * 1000})
            if (that.$store.getters.login_type != 'distributor') {
                that.$router.go(-1)
            }
          }).catch()
        } else {
          createGive(this.form).then(response => {
            this.loading = false
            this.$message({
              message: '添加成功',
              type: 'success',
              duration: 2 * 1000,
              onClose() {
                if (that.$store.getters.login_type != 'distributor') {
                    that.$router.go(-1)
                }
              }
            })
          }).catch()
        }


      },
      getItems(data) {

        let items = []
        let items_bn = []
        data.forEach(item => {
          items.push(item.itemId)
          items_bn.push(item.itemBn)
        })
        this.form.items = items
        this.form.items_bn = items_bn
      },
      getGiveInfo(id) {
        getGiveInfo(id).then(response => {

          this.form.line_many = parseInt(response.data.data.line_many)
          this.form.line_name = response.data.data.line_name

          this.relItems = response.data.data.itemTreeLists

          this.activity_date = [response.data.data.start_time * 1000, response.data.data.end_time * 1000]

        })
      },
      handleCancel() {
        this.$router.back(-1)
      },

    },
    mounted() {
      if (this.$route.params.limit_id) {
        this.getGiveInfo(this.$route.params.limit_id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// add.vue?731f1a84